function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApproveEngagements(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    id: "file-folder-approved",
    "data-name": "Flat Color",
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon flat-color",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "secondary",
    d: "M18,2H6A2,2,0,0,0,4,4v7a1,1,0,0,0,1,1H19a1,1,0,0,0,1-1V4A2,2,0,0,0,18,2Z",
    style: {
      fill: "#FF7300"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "primary",
    d: "M12.51,18.07A6.63,6.63,0,0,1,18,14a6.43,6.43,0,0,1,4,1V12a2,2,0,0,0-2-2H11.4L9.7,8.29A1,1,0,0,0,9,8H4a2,2,0,0,0-2,2V20a2,2,0,0,0,2,2h8.19A6.18,6.18,0,0,1,12.51,18.07Z",
    style: {
      fill: "#465867"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "secondary-2",
    "data-name": "secondary",
    d: "M17,22a1,1,0,0,1-.71-.29l-2-2a1,1,0,0,1,1.42-1.42L17,19.59l3.29-3.3a1,1,0,0,1,1.42,1.42l-4,4A1,1,0,0,1,17,22Z",
    style: {
      fill: "#FF7300"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApproveEngagements);
export default __webpack_public_path__ + "static/media/approve-engagements.8375ecf41e18f727126b5832faf72c49.svg";
export { ForwardRef as ReactComponent };